<script setup lang="ts">
import VerifyFollowingOfXAccount from "../Sidebars/VerifyFollowingOfXAccount.vue";
import type { FollowingOfXAccountSidebarProps } from "~/common/Types";

const opened = ref(false);
const propsData = ref<FollowingOfXAccountSidebarProps | null>(null);

function handleSidebar(data: FollowingOfXAccountSidebarProps) {
  console.log(data);
  propsData.value = data;
  opened.value = true;
}

onMounted(() => {
  globalOn("verifyFollowingOfXAccount", handleSidebar);
});

onBeforeUnmount(() => {
  globalOff("verifyFollowingOfXAccount", handleSidebar);
});
</script>

<template>
  <Sidebar v-if="opened && propsData" @close="opened = false">
    <VerifyFollowingOfXAccount
      :campaignWeekId="propsData.campaignWeekId"
      :handle="propsData.handle"
      :verification_id="propsData.verification_id"
      :verification_input="propsData.verification_input"
    />
  </Sidebar>
</template>
